export function formatMultiSelect(labels, emptyLabel = "Tất cả") {
  if (!labels?.length) {
    return emptyLabel;
  }

  const firstLabel = labels[0];

  if (labels.length === 1) {
    return String(firstLabel ?? "");
  }

  return `${firstLabel},...`;
}
